<template>
<div class="animated fadeIn mt-5">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>
          <b-form-group label="Campanha">
            <div class="form-inline">
                <b-form-input class="col-sm-2 mr-1" type="text" name="campaign_id"  v-model="item.campaign_id" placeholder="ID Campanha"  v-validate="'required'" :state="validateState('campaign_id')"></b-form-input>
                <b-form-input   class="col-md-6 col-sm-5 mr-1" type="text" name="dealer"  :value="item.campaign_id?item.campaign.data.name:''" :placeholder="'Campanha'" readonly ></b-form-input>
                <b-button  v-if="!item.id" class="col-md-3 col-sm-4"  variant="success" @click="doShowModal('campaigns')">selecionar</b-button>
            </div>
          </b-form-group>

          <modal-select modal="dealers-modal" v-validate="'required'" name="dealer_id" v-bind:readonly="item.id>0" v-bind:item-id="item.dealer_id" v-bind:item-name="''" v-on:select-item="selectDealer"  :state="validateState('dealer_id')"  ></modal-select>

          <b-form-group label="Zona">
            <div class="form-inline">
                <b-form-input class="col-sm-2 mr-1" type="text" name="zone"  v-model="item.zone" placeholder="Código de Zona"  v-validate="'required'" :state="validateState('zone')"></b-form-input>
                <b-form-input   class="col-md-6 col-sm-5 mr-1" type="text" name="dealer"  :value="item.zone?item.dealer.data.name:''" :placeholder="'Zona'" readonly ></b-form-input>
                <b-button  v-if="!item.id" class="col-md-3 col-sm-4"  variant="success" @click="doShowModal('zones')">selecionar</b-button>
            </div>
          </b-form-group>
          <b-form-row>
            <b-col md="4">
              <b-form-group label="Valor">
                <b-form-input type="number" step="0.01" min="0" name="value" v-model="item.value" placeholder="Valor"  v-validate="'required'" :state="validateState('value')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('value') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Operadores">
                <b-form-input type="number" step="1" min="0" name="operators" v-model="item.operators" placeholder="Operadores"  v-validate="'required'" :state="validateState('operators')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('operators') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Quantidade">
                <b-form-input type="number" step="1" min="0" name="quantity" v-model="item.quantity" placeholder="Quantidade"  v-validate="'required'" :state="validateState('quantity')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('quantity') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

          </b-form-row>


          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'bestof_objectives.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>


      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Debug </strong>
          </div>
          <pre>{{ item }}</pre>

        </b-card>
      </b-col>
      <!--/.col-->

      <b-modal no-enforce-focus @shown="showModal=true" @hidden="showModal=false" size="lg"  ref="dealersModal" id="dealersModal">
        <dealers v-if="showModal && modalType=='dealer'" height="400" v-on:select-item="selectDealer" />
        <zones v-if="showModal && modalType=='zones'" height="400" v-on:select-item="selectZone" />
        <bestof v-if="showModal && modalType=='campaigns'" height="400" v-on:select-item="selectCampaign" />
      </b-modal>
    </div>
  </form>

</div>
</template>

<script>
import Dealers from '@/views/dealers/dealers/modal.vue'
import DealersSelector from '@/views/dealers/dealers/input.vue'
import Zones from '@/views/dealers/zones/modal.vue'
import Bestof from '../campaigns/modal.vue'
export default {
  name: 'BestofObjectiveEdit',
  props: ['id'],
  components: { Dealers, Zones, Bestof, DealersSelector },
  data() {
    return {
      modalType: '',
      showModal: false,
      item: {
        zone: '',
        campaign: {
          data: {
            id: null,
            name: ''
          }
        },
        dealer: {
          data: {
            name: '',
            id: null
          }
        },
        value: 0,
        quantity: 0,
        operators: 0
      }
    }
  },
  methods: {
    selectDealer(e) {
      this.item.dealer_id = e.item.id
      this.item.dealer.data = e.item
    },
    selectCampaign(e) {
      this.item.campaign_id = e.item.id
      this.item.campaign.data = e.item
      this.$refs.dealersModal.hide()
    },
    selectZone(e) {
      this.item.zone = e.item.zone
      this.$refs.dealersModal.hide()
    },
    doShowModal(type) {
      this.modalType = type
      this.$refs.dealersModal.show()
    },
    hideModal() {
      this.$refs.dealersModal.hide()
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('bestof/objectives' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'bestof_objectives.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('bestof/objectives', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'bestof_objectives.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('bestof/objectives' + '/' + id)
        .then(response => {
          this.item = response.data.data
        })
        .catch(response => {
          this.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'bestof_objectives.index'
          })
        })
    }
  }
}
</script>
